import {
  CommonProps,
  NumberInput,
  type PropsEditorProps,
  Row,
  Section,
} from "./common";

export function NumberProps(props: PropsEditorProps): JSX.Element {
  const { field, onUpdate } = props;
  return (
    <>
      <CommonProps {...props} />
      <Section title="Range">
        <Row label="Min">
          <NumberInput
            value={field.min ?? null}
            onChange={(v) => onUpdate({ min: v ?? null })}
          />
        </Row>
        <Row label="Max">
          <NumberInput
            value={field.max ?? null}
            onChange={(v) => onUpdate({ max: v ?? null })}
          />
        </Row>
      </Section>
    </>
  );
}
